import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-03/lesson-22/task-01";

const task: Slide = {
  title: "Which statement is correct?",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
